module.exports = __webpack_public_path__ + "fonts/manrope-semibold.04cdef3f.woff";